import React, {Component} from 'react';
import {dialog, message} from "@posco/posco-ui-react";
import footerLogo from '../../static/img/login/footer_logo.png';
import guideFile from '../../static/pdfFile/Crosscert_Browser_PLM_Guide.pdf';
import {mesAutobind} from "@posco/posco-shared";
import {observer} from "mobx-react";
import PortalRepository from "../../layout/api/PortalRepository";
import O10g015462 from "./O10g015462";

@mesAutobind
@observer
class O10g015460 extends Component {
  state = {
    loginId: '',
    loginPassword: '',
    q01: false,
    q02: false,
    q03: false,
    q04: false,
    q05: false,
    q06: false,
    q07: false,
    q08: false,
  };

  nameInput = null;
  repository;

  // Line No. 37 : Failure Definition Function. => function -> const
  componentDidMount = () => {
    // this.importJsFiles();
    //localStorage 사용하므로 로그인페이지 접속시 한번 날려줌
    localStorage.clear();
    console.log("cookies===",  document.cookie )
    document.cookie = 'JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    const cookies = document.cookie.split('; ');
    for (let c = 0; c < cookies.length; c++) {
      const d = window.location.hostname.split('.');
      while (d.length > 0) {
        const cookieBase = encodeURIComponent(cookies[c].split(';')[0].split('=')[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
        const p = window.location.pathname.split('/');
        document.cookie = cookieBase + '/';
        while (p.length > 0) {
          document.cookie = cookieBase + p.join('/');
          p.pop();
        }
        d.shift();
      }
    }


    if (this.props.logout) {
      this.props.logout();
    }
  };

  questionsData = [
    { id: '1', question: '길이가 긴 많이 하는 질문은 이렇게에에에에에에에에에에길이가 긴 많이 하는 질문은 이렇게에에에에에에에에에에', answer: '길이가 긴 답변은 이렇게에에에에에에에에에에에길이가 긴 답변은 이렇게에에에에에에에에에에에길이가 긴 답변은 이렇게에에에에에에에에에에에' },
    { id: '2', question: '많이 하는 질문입니다.', answer: '답변입니다.' },
    { id: '3', question: '많이 하는 질문입니다.', answer: '답변입니다.' },
    { id: '4', question: '많이 하는 질문입니다.', answer: '답변입니다.' },
    { id: '5', question: '많이 하는 질문입니다.', answer: '답변입니다.' },
    { id: '6', question: '많이 하는 질문입니다.', answer: '답변입니다.' },
    { id: '7', question: '많이 하는 질문입니다.', answer: '답변입니다.' },
    { id: '8', question: '많이 하는 질문입니다.', answer: '답변입니다.' },
  ]


  /***로그인***/
  async login(){
    const {loginId} = this.state;
    //TODO 항상 else만 타게 한 코드..?
    console.log("loginId",loginId);
    if (this.props.isSSO && this.props.isSSO === false) {
      if (!this.props.mainPath) {
        alert('Layout에 이동할 main 경로를 입력해주세요.');
        return;
      }
      if (this.props.onLogin) {
        this.props.onLogin(loginId);
      }
    }
    else {
      var crypto = require("crypto");
      var shasum = crypto.createHash("sha256");

      await shasum.update(this.state.loginPassword);
      var output = await shasum.digest("hex");
     await this.onLoginCheck(loginId, output);
    }

  }


  onLoginCheck(id, pw){
    const userInfo = {
      id: id,
      password: pw,
    };

    try {
      return PortalRepository.instance.onLogin(userInfo)
        .then(async result => {
          console.log('onLoginCheck.instance.onLogin=>', result);
          if(!(result.data && result.data.nameValues)){
            console.log("result.data:::::", result.data);
            return dialog.alert(message("사용자 권한이 없습니다."));
          }
          if (result && result.status && result.status === 200) {
            /**인증서 열기**/
            await this.onLoginCert();
          }
        });
    } catch (err) {
      console.log(err.message);
    }
  }

  onLoginExternalSSO(data){
    console.log("사외로그인 sso!!!");
    const userInfo = {
      id: data.id,
      password: data.password,
      customerNumber: data.customerNumber,
      signature: data.signature,
    };

    try {
      return this.props.loginWithCert(userInfo)
        .then(result => {
          console.log('함수 따로 사용.instance.onLoginExternalSSO=>', result);
          if (result && result.status && result.status === 200) {
            result.data.nameValues.forEach(item => {
              localStorage.setItem(item.name, typeof item.value === "object" ? JSON.stringify(item.value) : item.value);
              if (item.name === 'Posco.auth.userInfo') {
                localStorage.setItem('gcsCompCode', item.value.gcsCompCode);
              }
            })

            localStorage.setItem('Posco.auth.userId', userInfo.id);
            window.location.href = '/o10t01-front/o10g01-front/o10g015420';  //설계자료실
          }
        });
    } catch (err) {
      console.log(err.message);
    }
  }

  onChange(e) {
    // console.log("onChange e, data::",e);
    // console.log("onChange e, data::",e.currentTarget.value);
    this.setState({
      loginId: e.currentTarget.value,
    });
    // this.props.onChangeId(data.value);
  }

  onChangePassword(e, data) {
    // console.log("onChangePassword e, data::", e, data)
    this.setState({
      loginPassword: e.currentTarget.value,
    });

    //  this.props.onChangePassword(data.value);
  }


  handleKeyPress(event) {
    if (event.key === 'Enter') {
      console.log('Enter');
      this.login();
      // this.login();//원래 로그인
    }
  }

  /**인증서**
   * @param e
   */


  /**UUID생성**/
   uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }



  /**인증서 여는 함수**/
  async onLoginCert(){
    // console.log("unisign====", unisign);
    // unisign.SetConfigInfo({ Language: "ko-kr" }); //한글로 인증서 선택창 띄우기
    // }
    // const otp = await getOtp();
    // this.state.loginId;
    // this.state.loginPassword;
    var id=this.state.loginId;
    console.log("this.state.id::", id);
    /**비번 암호화**/
    var crypto = require("crypto");
    var shasum = crypto.createHash("sha256");

    await shasum.update(this.state.loginPassword);
    var outputPW = await shasum.digest("hex");
    // console.log("암호화 PW::", outputPW);
    // 사용 예시
    let uuid =this.uuidv4();
    console.log("uuid::", uuid);

    const thisObj = this;
    /**인증서 여는 함수**/
    unisign.SignDataEx(
      uuid,// otp, // UUID 필요. 우선 시간으로 구성
      null,
      async function (resultObject) {
        if (null === resultObject || "" === resultObject) {
          unisign.GetLastError(function (errCode, errMsg) {
            alert("Error code : " + errCode + "\n\nError Msg : " + errMsg);
          });
        } else {
          console.log("else로 들어옴 resultObject::",resultObject );
          if (typeof resultObject.certAttrs.subjectName === "undefined") {
            //                                alert(" 사용자 DN 선택이 취소 되었습니다.");Digital Certificate
            alert("사용자 DN 선택이 취소 되었습니다.");
          }
          /**기존코드**/
            else {
            const certDN = resultObject.certAttrs.subjectName;
            let customer_code = "";
            //ex - e=test@dd.com,cn=JMKIM[B=EMK C=IVIO5](20210416131931556c),ou=Managed PKI POSCO CA,o=POSCO,c=KR
            /*
                resultObject.certAttrs.subjectName 에서 나오는 결과값 중 BIZ Code , Customer Code 항목을 파싱하여
                              시스템에서 사용 가능한 BIZ Code , Customer Code 임을 확인하여 로그인 진행한다.
            */
            if (certDN){
              customer_code = certDN.substring(certDN.lastIndexOf("C=")+2, certDN.lastIndexOf("]"));
            }

            // const thisObj = this;
            unisign.VerifySignData(resultObject.signedData, async function (plainText)
            {
              if (uuid)
              {
                /*
                인증서 로직 종료 로그인 혹은 비즈니스로직 시작
                */
                document.cookie = "CODE="+customer_code;
                // objForm.f_recall.value    = "N";
                // objForm.f_certType.value   = "WEB";
                // objForm.action = "<%=formAction%>";
                // objForm.submit();
                console.log(" resultObject.signedData",  resultObject.signedData);
                console.log(" document.cookie==",  document.cookie);
                console.log(" customer_code==",  customer_code);
                const data = {
                  id: id,
                  password: outputPW,
                  customerNumber: customer_code,
                  signature: resultObject.signedData,
                };

                /**인증서, 로그인 모두 성공 후 화면 들어가기**/
                thisObj.onLoginExternalSSO(data);
              //   try {
              //     /***인증서 api***/
              //     console.log("인증서 api 시작 try");
              //     const res =  axios.post(`${apiUrlLogin}/cert`, data, config)
              //       .then(result => {
              //         console.log('인증서 정보::: ', result);
              //         if (result && result.status && result.status === 200) {
              //           result.data.nameValues.forEach(item => {
              //             localStorage.setItem(item.name, typeof item.value === "object" ? JSON.stringify(item.value) : item.value);
              //             if (item.name === 'Posco.auth.userInfo') {
              //               localStorage.setItem('gcsCompCode', item.value.gcsCompCode);
              //             }
              //           })
              //
              //           localStorage.setItem('Posco.auth.userId', data.id);
              //           window.location.href = '/o10t01-front/o10g01-front/o10g015420';  //설계자료실
              //         }
              //       });
              //
              //     return res;
              //   } catch (err) {
              //     console.log(err.message);
              //   }
              }
              else
              {
                unisign.GetLastError(function(errCode, errMsg)
                {
                  alert('Error code : ' + errCode + '\n\nError Msg : ' + errMsg);
                });
              }
            });
          }
          /**기존코드 끝**/


        }
      },
    );
  };

   /**로그인 버튼 클릭**/
  async onClickLogin(e, data) {
    e.preventDefault();
    console.log("e, data==", e, data);

    // 1. 로그인 확인
     await this.login();

    console.log("onClickLogin");

    // location='SystemProperties.jsp'
    // this.login(); //원래 로그인
  }

   handleQuestion = (e) => {
    const { id } = e.target;
    this.setState({[id]:!this.state[id]}) //원래 기존값의 반대를 넣어줌
    // setQuestions({ ...quesReset, [id]: !questions[id] }); //기존코드
  }

  /**설계자료실**/
  openReference(e) {
    e.preventDefault();
    console.log("설계자료실");
    window.open('/o10g01-front/o10g015420')
    // this.login();
  }

  /**많이하는 질문**/
  openQuestion(e) {
    e.preventDefault();
    console.log("많이하는질문");
    //TODO 주석 풀어야됨
    // window.open('/o10g01-front/o10g015390')
    // this.login();
  }

  /**포스코인증센터**/
  openCenter(e) {
    e.preventDefault();
    window.open('https://www.steel-n.com/CrossCerts')
    // this.login();
  }

  /**포스코인증센터가이드**/
  openCenterGuide(e) {
    e.preventDefault();
    console.log("포스코인증센터가이드");
    const fileUrl=guideFile;
    const fileName='Crosscert_Browser_PLM_Guide.pdf';

    fetch(fileUrl, {
      headers: {
        'Content-Type': 'application/pdf',
      },
    })
      .then(response=>response.blob())
        .then(blob=>{
          const blobUrl=window.URL.createObjectURL(blob);

          const link=document.createElement('a');
          link.href=blobUrl;
          link.download=fileName;

          link.dispatchEvent(new MouseEvent('click',{bubbles:true, cancelable:true, view:window}));
           window.URL.revokeObjectURL(blobUrl);
        });
}


  render() {
    return (
      <>
        <header className="login_header ">
          <div className="header_btnWrap">
            {/*<button>HOME</button>*/}
            <button onClick={this.openReference}>설계자료실</button>
            {/* <button onClick={this.openQuestion}>많이하는질문</button> */}
          </div>

          <div className="login_main">
            <div className="login_title">
              <h1>윤리적 투자,<br/>저탄소 친환경 투자</h1>
              <h2>POSCO가 앞장섭니다.</h2>
              <p>Ethical Investment, Low-Carbon, Eco-Friendly Investment POSCO Takes The Lead.</p>
            </div>

            <div className="login_block">
              <h3>LOGIN</h3>
              <div className="inputBox">
                <input type="text" placeholder="ID"
                       onChange={this.onChange}
                       value={this.state.loginId}
                       onKeyPress={this.handleKeyPress}
                       ref={(input) => {
                         this.nameInput = input;
                       }}
                       />
                <input type="password" placeholder="PASSWORD"
                       onChange={this.onChangePassword}
                       value={this.state.loginPassword}
                       onKeyPress={this.handleKeyPress}
                />
                <div>
                  <input type="checkbox" id="saveID"/>
                  <label htmlFor="saveID">아이디 저장</label>
                </div>
              </div>
              <button className="btnLogin type1" onClick={this.onClickLogin}>로그인</button>
              <button className="btnLogin type2" onClick={this.openCenter}>포스코인증센터</button>
              <ul className="login_btnWrap">
                <li>
                  <button onClick={this.props.openModal}>아이디/비밀번호찾기</button>
                </li>
                <li>
                  <button onClick={this.props.openSignUpModal}>회원가입</button>
                </li>
                <li>
                  <button onClick={this.openCenterGuide}>인증센터가이드</button>
                </li>
              </ul>
            </div>
          </div>

          <div className="imgWrap">
            <ul>
              <li style={{cursor: "pointer"}}>
                <div className="imgIcon" onClick={this.openCenter}/>
                <p onClick={this.openCenter}>포스코 인증센터</p>
              </li>
              <li style={{cursor: "pointer"}}>
                <div className="imgIcon" onClick={this.openCenterGuide}/>
                <p onClick={this.openCenterGuide}>인증센터가이드</p>
              </li>
              <li style={{cursor: "pointer"}}>
                <div className="imgIcon" onClick={this.openReference}/>
                <p onClick={this.openReference}>설계자료실</p>
              </li>
              {/* <li>
                <div className="imgIcon" onClick={this.openQuestion}/>
                <p onClick={this.openQuestion}>많이하는질문</p>
              </li> */}
            </ul>
          </div>
        </header>

        {/*<section className="login_section">*/}
        {/*  /!* 왼쪽 콘텐츠 넣을 시 사용 *!/*/}
        {/*  <div className="content_left"></div>*/}

        {/*  <div className="content_right">*/}
        {/*    <div className="titleWrap">*/}
        {/*      <h4>많이 하는 질문</h4>*/}
        {/*      <button>더보기&#62;</button>*/}
        {/*    </div>*/}
        {/*    <ul className="quesList">*/}
        {/*      {*/}
        {/*      this.questionsData.map((props) => {*/}
        {/*        return (*/}
        {/*          <li key={`ques${props.id}`}>*/}
        {/*            <div id={`q0${props.id}`} className={this.state[`q0${props.id}`] ? 'question quesAct' : 'question'}*/}
        {/*                 onClick={this.handleQuestion}>*/}
        {/*              <span className="questionIcon">Q</span>*/}
        {/*              <span>{props.question}</span>*/}
        {/*            </div>*/}
        {/*            <div className="answer" style={{'display': this.state[`q0${props.id}`] ? 'block' : 'none'}}>*/}
        {/*              <span className="answerIcon">A</span>*/}
        {/*              <span>{props.answer}</span>*/}
        {/*            </div>*/}
        {/*          </li>*/}
        {/*        )*/}
        {/*      })*/}
        {/*    }*/}
        {/*    </ul>*/}
        {/*  </div>*/}
        {/*</section>*/}

        <footer className="loginFooter">
          <div className="copyright">
            <img src={footerLogo}/>
            <span>CopyrightⓒPOSCO All rights reserved.</span>
          </div>
          <div className="corpInform">
            <ul className="footer_btnWrap">
              {/*<li>*/}
              {/*  <button>이용약관</button>*/}
              {/*</li>*/}

              <li>
                {/*<button onClick={this.props.openPrivacyModal}>개인정보처리방침</button>*/}
                <O10g015462
                  openPrivacy = {this.props.openPrivacy}
                  close = {this.props.close}
                  version={this.props.version}
                  explan={this.props.explan}
                  setExplan={this.props.setExplan}
                  searchVersion={this.props.searchVersion}
                  handleSelectChange={this.props.handleSelectChange}
                  onFindExpl={this.props.onFindExpl}
                  onChange={this.props.onChange}
                />
              </li>
              {/* <li>
                            <button>라이선스</button>
                        </li> */}
              {/*<li>*/}
              {/*  <button>운영자 개발정보</button>*/}
              {/*</li>*/}
            </ul>
            <p>(우)37859 경상북도 포항시 남구 동해안로 6261(포항시 남구 괴동동1) | 사업자등록번호 301-87-02315 | 대표 이희근 | 대표전화 02-3457-0114</p>
          </div>
        </footer>
      </>
    );
  }

}

export default O10g015460;
